/**
 * Gérer l'intéractivité du menu principal.
 *
 * @export
 * @class Menu
 */
export default class Menu {
    // Le menu
    menuBtn; // Le bouton du menu
    burger; // L'icône burger
    menuModal; // Le modal du menu
    /**
     * Créer une instance de Menu.
     *
     * @memberof Menu
     */
    constructor() {
        // Mettre la main sur les éléments qui permettent d'afficher et de cacher le menu
        this.menuBtn = document.getElementById('menu-btn');
        this.burger = document.getElementById('burger');
        this.menuModal = document.getElementById('menu-modal');
        // Gérer le clic sur le bouton menu
        this.menuBtn.addEventListener("click", () => { this.toggle(); });
        // Fermer la navigation si on clic n'importe où ailleurs dans la fenêtre.
        window.addEventListener("click", (ev) => { this.gererClickWindow(ev); });
        // Mettre la main sur les liens qui ouvrent les sous-menus
        let liensSousMenus = document.querySelectorAll('.navigation__lien--top');
        // Gérer le clic sur les liens qui ouvrent les sous-menus
        Array.from(liensSousMenus).forEach((lienSousMenu) => lienSousMenu.addEventListener('click', this.toggleSousMenu));
    }
    /**
     * Ouvrir — ou fermer — le menu.
     *
     * @public
     * @memberof Menu
     */
    toggle() {
        if (this.isOuvert()) {
            this.fermer();
        }
        else {
            this.ouvrir();
        }
    }
    /**
     * Afficher - ou cacher - le sous-menu
     *
     * @public
     * @memberof Menu
     */
    //private toggleSousMenu(ev: Event): void
    toggleSousMenu() {
        //console.log("Dans toggleSousMenu");
        // Mettre la main sur le sous-menu sur lequel l'utilisateur a cliqué
        const cible = this;
        // Mettre la main sur les liens qui ouvrent les sous-menus
        let liensSousMenus = document.querySelectorAll('.navigation__lien--top');
        // Boucler sur tous les sous-menu
        // Fermer le ou les sous-menus déjà ouverts (le cas échéant)
        // Toggle du sous-menu sur lequel l'utilisateur a cliqué
        Array.from(liensSousMenus).forEach((lienSousMenu) => {
            // Est-ce qu'on est rendu sur le sous-menu sur lequel l'utilisateur a cliqué
            if (cible.id == lienSousMenu.id) {
                // Toggle du sous-menu sur lequel l'utilisateur a cliqué
                // Mettre la main sur le sous-menu en question
                let leSousMenu = document.getElementById(cible.id + '-menu');
                // Mettre la main sur l'icone
                let icone = document.getElementById(cible.id + '-icone');
                // Vérifier le statut du menu
                if (leSousMenu.style.display == "flex") {
                    // Le menu est ouvert, il faut le fermer
                    leSousMenu.style.display = "";
                    // Il faut renverser l'icone
                    icone.style.transform = 'rotate(0)';
                }
                else {
                    // Le menu est fermé, il faut l'ouvrir
                    leSousMenu.style.display = 'flex';
                    // Il faut tourner l'icone
                    icone.style.transform = 'rotate(180deg)';
                }
            }
            else {
                let sousMenu = document.getElementById(lienSousMenu.id + '-menu');
                if (sousMenu.style.display == "flex") {
                    // Fermer le sous-menu déjà ouvert
                    sousMenu.style.display = "";
                    // Rotationner la flèche
                    let icone = document.getElementById(lienSousMenu.id + '-icone');
                    icone.style.transform = 'rotate(0)';
                }
            }
        });
    }
    /**
     * Gérer un click sur la fenêtre.
     *
     * @private
     * @memberof Menu
     * @param ev MouseEvent
     */
    gererClickWindow(ev) {
        if (!this.isOuvert) {
            return;
        }
        if (!(ev.target instanceof Node)) {
            return;
        }
        if (this.menuBtn.contains(ev.target) ||
            this.menuModal.contains(ev.target)) {
            return;
        }
        this.fermer();
    }
    /**
     *
     * @returns boolean  Vrai si le menu est déjà ouvert, faux sinon
     */
    isOuvert() {
        if (this.menuModal.style.display == "block") {
            return true;
        }
        return false;
    }
    /**
     * Afficher le modal du menu
     *
     * @private
     * @memberof Menu
     */
    ouvrir() {
        // Afficher menu
        this.menuModal.style.display = 'block';
        this.menuBtn.setAttribute('aria-expanded', 'true');
        // Modifier l'icône
        this.burger.innerHTML = 'close';
        this.burger.setAttribute('aria-hidden', 'true');
    }
    /**
     * Cacher le modal du menu
     *
     * @private
     * @memberof Menu
     */
    fermer() {
        // Revenir au css initial, qui est de fermer le menu
        this.menuModal.style.display = '';
        this.menuBtn.setAttribute('aria-expanded', 'false');
        // Modifier l'icône
        this.burger.innerHTML = 'menu';
        this.burger.setAttribute('aria-hidden', 'false');
    }
}
